import { Components, Theme } from '@mui/material/styles';

declare module '@mui/material/Accordion' {
  interface AccordionPropsSizeOverrides {
    large: true;
  }
}
export const muiAccordionOverride: Components<Theme>['MuiAccordion'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      margin: 0,
      boxShadow: 'none',
      borderStyle: 'solid',
      borderWidth: 0,
      borderColor: theme.vars.palette.grey[50],
      '&.Mui-expanded': {
        margin: 0,
        boxShadow: 'none',
      },
    }),
  },
  defaultProps: {
    elevation: 0,
    disableGutters: true,
    variant: 'outlined',
  },
};
